"use client";

import { c as _c } from "react/compiler-runtime";
import styles from "../NextGen.module.scss";
import { Container, Row, Col, Table } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { commonApiFetch } from "@/services/api/common-api";
import Pagination from "@/components/pagination/Pagination";
import type { Transaction } from "@/entities/ITransaction";
import LatestActivityRow from "@/components/latest-activity/LatestActivityRow";
import type { NextGenCollection, NextGenLog } from "@/entities/INextgen";
import { NextGenCollectionProvenanceRow } from "../collectionParts/NextGenCollectionProvenance";
interface Props {
  collection: NextGenCollection;
  token_id: number;
}
const PAGE_SIZE = 25;
export default function NextGenTokenProvenance(props) {
  const $ = _c(52);
  const scrollTarget = useRef(null);
  const logsScrollTarget = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [transactions, setTransactions] = useState(t0);
  const [transactionsLoaded, setTransactionsLoaded] = useState(false);
  const [totalResults, setTotalResults] = useState(0);
  const [page, setPage] = useState(1);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [logs, setLogs] = useState(t1);
  const [logsLoaded, setLogsLoaded] = useState(false);
  const [logsTotalResults, setLogsTotalResults] = useState(0);
  const [logsPage, setLogsPage] = useState(1);
  let t2;
  if ($[2] !== props.token_id) {
    t2 = function fetchResults(mypage) {
      setTransactionsLoaded(false);
      commonApiFetch({
        endpoint: `nextgen/tokens/${props.token_id}/transactions?page_size=${PAGE_SIZE}&page=${mypage}`
      }).then(response => {
        setTotalResults(response.count);
        setTransactions(response.data);
        setTransactionsLoaded(true);
      });
    };
    $[2] = props.token_id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const fetchResults = t2;
  let t3;
  if ($[4] !== fetchResults || $[5] !== page) {
    t3 = () => {
      fetchResults(page);
    };
    $[4] = fetchResults;
    $[5] = page;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== page) {
    t4 = [page];
    $[7] = page;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== props.collection.id || $[10] !== props.token_id) {
    t5 = function fetchLogsResults(mypage_0) {
      setLogsLoaded(false);
      commonApiFetch({
        endpoint: `nextgen/collections/${props.collection.id}/logs/${props.token_id}?page_size=${PAGE_SIZE}&page=${mypage_0}`
      }).then(response_0 => {
        setLogsTotalResults(response_0.count);
        setLogs(response_0.data);
        setLogsLoaded(true);
      });
    };
    $[9] = props.collection.id;
    $[10] = props.token_id;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const fetchLogsResults = t5;
  let t6;
  if ($[12] !== fetchResults || $[13] !== page) {
    t6 = () => {
      fetchResults(page);
    };
    $[12] = fetchResults;
    $[13] = page;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== page) {
    t7 = [page];
    $[15] = page;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  useEffect(t6, t7);
  let t8;
  if ($[17] !== fetchLogsResults || $[18] !== logsPage) {
    t8 = () => {
      fetchLogsResults(logsPage);
    };
    $[17] = fetchLogsResults;
    $[18] = logsPage;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== logsPage) {
    t9 = [logsPage];
    $[20] = logsPage;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  useEffect(t8, t9);
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Row><Col><h3>Token Provenance</h3></Col></Row>;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== transactions) {
    t11 = transactions.map(_temp);
    $[23] = transactions;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11) {
    t12 = <Row className={`pt-2 ${styles.logsScrollContainer}`}><Col><Table bordered={false} className={styles.logsTable}><tbody>{t11}</tbody></Table></Col></Row>;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== page || $[28] !== totalResults || $[29] !== transactionsLoaded) {
    t13 = totalResults > PAGE_SIZE && transactionsLoaded && <Row className="text-center pt-4 pb-4"><Pagination page={page} pageSize={PAGE_SIZE} totalResults={totalResults} setPage={function (newPage) {
        setPage(newPage);
        if (scrollTarget.current) {
          scrollTarget.current.scrollIntoView({
            behavior: "smooth"
          });
        }
      }} /></Row>;
    $[27] = page;
    $[28] = totalResults;
    $[29] = transactionsLoaded;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t12 || $[32] !== t13) {
    t14 = <Container className="no-padding" ref={scrollTarget}>{t10}{t12}{t13}</Container>;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Row><Col><h3>Collection Provenance</h3></Col></Row>;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== logs || $[36] !== props.collection) {
    let t17;
    if ($[38] !== props.collection) {
      t17 = (log, index) => <NextGenCollectionProvenanceRow collection={props.collection} log={log} key={`${log.block}-${log.id}`} disable_link={true} odd={index % 2 !== 0} />;
      $[38] = props.collection;
      $[39] = t17;
    } else {
      t17 = $[39];
    }
    t16 = logs.map(t17);
    $[35] = logs;
    $[36] = props.collection;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[40] !== t16) {
    t17 = <Row className="pt-2"><Col>{t16}</Col></Row>;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== logsLoaded || $[43] !== logsPage || $[44] !== logsTotalResults) {
    t18 = logsTotalResults > PAGE_SIZE && logsLoaded && <Row className="text-center pt-4 pb-4"><Pagination page={logsPage} pageSize={PAGE_SIZE} totalResults={logsTotalResults} setPage={function (newPage_0) {
        setLogsPage(newPage_0);
        if (logsScrollTarget.current) {
          logsScrollTarget.current.scrollIntoView({
            behavior: "smooth"
          });
        }
      }} /></Row>;
    $[42] = logsLoaded;
    $[43] = logsPage;
    $[44] = logsTotalResults;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t17 || $[47] !== t18) {
    t19 = <Container className="pt-4 no-padding" ref={logsScrollTarget}>{t15}{t17}{t18}</Container>;
    $[46] = t17;
    $[47] = t18;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== t14 || $[50] !== t19) {
    t20 = <>{t14}{t19}</>;
    $[49] = t14;
    $[50] = t19;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  return t20;
}
function _temp(tr) {
  return <LatestActivityRow tr={tr} hideNextgenTokenId={true} key={`${tr.from_address}-${tr.to_address}-${tr.transaction}-${tr.token_id}`} />;
}